import logoImg from "assets/logo.svg";
import { Loader } from "processhub-components-lib";
import classNames from "utilities/ClassNames";
import { SplashScreenInterface } from "./domain/types";
import { ProgressBar } from "processhub-components-lib";

export const SplashScreen: React.FunctionComponent<SplashScreenInterface> = ({
  open = false,
  status,
  isScaled,
  progressStatus,
}) => {
  if (open) {
    return (
      <>
        <div className="absolute grid place-content-center h-full w-full bg-black">
          <div className="flex flex-col items-center gap-5">
            <img
              src={logoImg}
              alt="Processhub"
              className={classNames(isScaled ? "logo-large" : "logo-medium")}
            />
            <Loader />
            <div className={classNames(isScaled ? "text-2xl" : "text-base")}>
              {status}
            </div>
            <div className="w-full">
              <ProgressBar value={progressStatus} />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
